module.exports = __webpack_public_path__ + "static/img/135.7b865e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/135.png
// module id = 3p0+
// module chunks = 0